import ICurrentUserState from "./ICurrentUserState";

export enum IAuthActionTypes {
  LOGIN_REQUEST = "AUTH/LOGIN_REQUEST",
  LOGIN_SUCCESS = "AUTH/LOGIN_SUCESS",
  LOGIN_FAILURE = "AUTH/LOGIN_FAILURE",

  OTP_REQUEST = "AUTH/OTP_REQUEST",
  OTP_SUCCESS = "AUTH/OTP_SUCCESS",
  OTP_FAILURE = "AUTH/OTP_FAILURE",
  OTP_CANCEL = "AUTH/OTP_CANCEL",

  VERIFY_OTP_REQUEST = "AUTH/VERIFY_OTP_REQUEST",
  VERIFY_OTP_SUCCESS = "AUTH/VERIFY_OTP_SUCCESS",
  VERIFY_OTP_FAILURE = "AUTH/VERIFY_OTP_FAILURE",

  FETCH_CURRENT_USER_SUCCESS = "FETCH_CURRENT_USER_SUCCESS",
  SILENT_LOGIN = "AUTH/SILENT_LOGIN",
  LOGOUT = "AUTH/LOGOUT",
  REGISTER = "AUTH/REGISTER",

  LOGIN_FR_VERIFY_REQUEST = "AUTH/LOGIN_FR_VERIFY_REQUEST",
  LOGIN_FR_VERIFY_SUCCESS = "AUTH/LOGIN_FR_VERIFY_SUCESS",
  LOGIN_FR_VERIFY_FAILURE = "AUTH/LOGIN_FR_VERIFY_FAILURE",
}

export type IAuthState = {
  access_level?: string;
  otperrormessage: string;
  isuserLogin?: boolean;
  verifytoken: string;
  authtoken: string | null;
  isotpverified: boolean | null;
  isotpreceived: boolean | null;
  currentuserinfo: ICurrentUserState;
  isFRVerified: boolean | null;
  is_fr_verification_in_progress: boolean | null;
  frError?: string;
  is_in_api_call?: boolean | null;
};

export type IOtpState = {
  mobile: string | null;
};

export type IAuthPayload = {
  auth_token: string;
  entity_id: string;
  isotpverified: boolean | null;
  isotpreceived: boolean | null;
  otperrormessage: string;
  user_id: string;
  user_name: string;
  access_level?: string;
  frError?: string;
  error?: string;
  isuserLogin?:boolean
};

export type IAuthActionCreator = {
  type: string;
  payload: IAuthPayload;
};
